import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
/** composants **/
import { Navbar } from '../Navbar';
import Footer from '../components/Footer';
import { Helmet } from "react-helmet";
import BackHeaderTop from "../components/BackHeaderTop";

const slugToCategory = {
  "notaire-immobilier": "Notaire et immobilier",
  "notaire-et-mariage": "Notaire et mariage",
  "notaire-et-pma": "Notaire et PMA",
  "notaire-et-pacs": "Notaire et PACS"
};

const categoryToSlug = Object.fromEntries(
  Object.entries(slugToCategory).map(([slug, label]) => [label, slug])
);

export default function BlogPage(args) {
  const { categorySlug } = useParams();
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [activeCategory, setActiveCategory] = useState(slugToCategory[categorySlug] || "Notaire et immobilier");

  useEffect(() => {
    fetch("/data/articles.json")
      .then((res) => res.json())
      .then(setPosts)
      .catch((err) => console.error("Erreur chargement articles:", err));
  }, []);

  const handleTabClick = (label) => {
    const slug = categoryToSlug[label];
    if (slug) {
      navigate(`/blog/${slug}`);
      setActiveCategory(label);
    }
  };

  const filteredPosts = posts.filter((post) => post.category === activeCategory);

  return (
    <>
      <Helmet>
        <title>Clotere.fr simplifie votre passage chez le notaire | Donation, achat/vente immobilière, Pacs, Contrat de mariage....etc</title>
        <meta name="robots" content="index,follow" />
        <meta name="googlebot" content="index,follow" />
        <meta name='description' content='Clotere.fr vous permet de gérer et simplifier vos démarches chez le notaire en ligne : contrat de mariage, documents notariés PMA, trouver un notaire pour acheter un bien immobilier, vendre son bien immobilier, trouver un notaire, etc' />
        <meta property="og:url" content="https://clotere.fr" />
        <meta property="og:site_name" content="Clotere" />
        <meta property="og:image" content="https://clotere.fr/facebook-share-webp" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div>
        <Navbar user={args.user} />

        <div className="py-12 relative">
          <BackHeaderTop />

          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mb-12 flex justify-center gap-4 flex-wrap">
              {Object.values(slugToCategory).map((cat) => (
                <button
                  key={cat}
                  onClick={() => handleTabClick(cat)}
                  className={`px-4 py-2 rounded-full text-sm font-medium border transition ${
                    activeCategory === cat
                      ? "bg-indigo-600 text-white border-indigo-600"
                      : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>

            <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
              {filteredPosts.map((post) => (
                <article key={post.url} className="flex flex-col items-start justify-between">
                  <div className="relative w-full">
                    <img
                      alt={post.title}
                      src={post.image}
                      className="aspect-video w-full rounded-2xl bg-gray-100 object-cover sm:aspect-2/1 lg:aspect-3/2"
                    />
                    <div className="absolute inset-0 rounded-2xl ring-1 ring-gray-900/10 ring-inset" />
                  </div>
                  <div className="max-w-xl">
                    <div className="mt-8 flex items-center gap-x-4 text-xs">
                      <span className="no-underline relative z-10 rounded-full bg-indigo-100 px-3 py-1.5 font-medium text-gray-600">
                        {post.category}
                      </span>
                    </div>
                    <div className="group relative">
                      <h3 className="mt-3 text-lg/6 font-semibold group-hover:text-gray-600">
                        <a href={post.url} target="_blank" rel="noreferrer" className="no-underline text-gray-900">
                          <span className="absolute inset-0" />
                          {post.title}
                        </a>
                      </h3>
                      <p className="line-clamp-3 text-sm/6 text-gray-600">{post.description}</p>
                    </div>
                    <div className="relative mt-8 flex items-center gap-x-4">
                      <img
                        alt="Clotere notaire"
                        src="https://framerusercontent.com/images/Cihku2yTTOUo6fm04vXVGhV7Q.png"
                        className="size-10 rounded-full bg-gray-100"
                      />
                      <div className="text-sm/6">
                        <p className="font-semibold text-gray-900 m-0">Clotere</p>
                      </div>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
